import { StyleSheet, Platform } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export function getOrgBrandedLandingStyles(theme: Theme) {
  return StyleSheet.create({
    loadingContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      padding: 20,
      paddingTop: Platform.OS === 'web' ? 40 : 60,
    },
    loadingText: {
      color: theme.white,
      marginTop: 16,
      fontSize: 16,
      fontWeight: '500',
    },
    errorTitle: {
      fontSize: 24,
      fontWeight: '700',
      color: theme.white,
      textAlign: 'center',
      marginBottom: 8,
    },
    errorMessage: {
      color: theme.white,
      textAlign: 'center',
      marginBottom: 24,
    },
    primaryButton: {
      paddingHorizontal: 32,
      paddingVertical: 16,
      borderRadius: 14,
      backgroundColor: theme.white,
      alignItems: 'center',
    },
    primaryButtonText: {
      fontSize: 16,
      fontWeight: '700',
      color: theme.primary,
    },
    pressed: {
      opacity: 0.85,
    },
  });
}
